import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@common/services/configuration.service';
import { WINDOW } from '@common/window.provider';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly config = inject(ConfigurationService);
  private readonly window = inject(WINDOW);

  handleError(error: unknown): void {
    const chunkFailedMessage = /Loading chunk \d+ failed/;
    const message = this.extractMessage(error);

    if (!this.config.get('production')) {
      console.error('handleError: ', error);
    }

    if (chunkFailedMessage.test(message)) {
      this.window.location.reload();
    }
  }

  private extractMessage(error: unknown): string {
    if (!error) return '';

    if (typeof error === 'string') return error;

    if (error instanceof Error) return error.message;

    if (typeof error === 'object') {
      const e = error as { message?: string; reason?: unknown };

      if (e.reason) return this.extractMessage(e.reason);

      if (e.message) return e.message;
    }

    return '';
  }
}
